export default __webpack_public_path__ + "499f21104fb1a141ff563a5e60600466.svg";